module.exports = __webpack_public_path__ + "static/media/lucy.03412e82.jpg";